import moment from "moment";
export class StaffLetter {
  StaffID;
  DateIssue;
  Seq;
  DocTypeCode;
  TempCode;
  IssueBy;
  DocContent;
  Remarks;
  AddBy;
  IsNew;
  constructor() {
    this.StaffID = "";
    this.DateIssue = moment().format("YYYY-MM-DD");
    this.Seq = "";
    this.DocTypeCode = "";
    this.TempCode = "";
    this.IssueBy = "";
    this.DocContent = "";
    this.Remarks = "";
    this.AddBy = "";
    this.ModifyBy = "";
    this.IsNew = false;
  }
}



// WEBPACK FOOTER //
// ./src/model/StaffLetter.js